/**
 * Envía el mensaje del aficionado a la API.
 * * @param {Object} dataPayload - Objeto con la información { message, sender, phone }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SendMessage = async (dataPayload) => {
    try {
        // Construimos el cuerpo de la petición asegurando los nombres correctos
        const requestBody = {
            message: dataPayload.message,
            sender: dataPayload.sender,
            phone: dataPayload.phone // puede ser null o string
        }

        const response = await fetch(process.env.REACT_APP_API_URL + "messages/send", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        })
        
        // Verificamos si la respuesta HTTP no fue exitosa (ej: 400, 500)
        if (!response.ok) {
            const errorData = await response.json()

            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible enviar tu dedicatoria. Inténtalo nuevamente.' 
            }
        }
        
        const responseData = await response.json()
        
        // Retorno exitoso
        return { success: true, data: responseData }

    } catch (error) {
        // Error de red o conexión
        return { 
            success: false, 
            message: 'Error de conexión. Por favor revisa tu internet e inténtalo de nuevo.' 
        }
    }
}

export { SendMessage };